import api from "../instance/axios_instance.ts";
import { CustomerInterface } from '../interface/customerInterface.ts';

const NewCustomer = async (newUser: CustomerInterface ): Promise<CustomerInterface> => {
    try {
        const response = await api.post<CustomerInterface>('/new_customer', newUser);
        return response.data;
    } catch (error) {
        console.error('Error creating customer:', error);
        throw error;
    }
};

export default NewCustomer;